<template>
  <div>
    <!--<DarkModeSwitcher />-->
    <div class="container sm:px-10">
      <div class="block xl:grid grid-cols-2 gap-4">
        <!-- BEGIN: Register Info -->
        <div class="hidden xl:flex flex-col min-h-screen">
          <a href="" class="-intro-x flex items-center pt-5">
            <img
              alt="Icewall Tailwind HTML Admin Template"
              class="w-6"
              :src="require(`@/assets/images/logo.svg`)"
            />
            <span class="text-white text-lg ml-3">
              Rat<span class="font-medium">Técnico</span>
            </span>
          </a>
          <div class="my-auto">
            <img
              alt="Icewall Tailwind HTML Admin Template"
              class="-intro-x w-1/2 -mt-16"
              :src="require(`@/assets/images/reports.svg`)"
            />
            <!--
            <div
              class="-intro-x text-white font-medium text-4xl leading-tight mt-10"
            >
              A few more clicks to <br />
              sign up to your account.
            </div>
            <div
              class="-intro-x mt-5 text-lg text-white text-opacity-70 dark:text-gray-500"
            >
              Manage all your e-commerce accounts in one place
            </div>-->
          </div>
        </div>
        <!-- END: Register Info -->
        <!-- BEGIN: Register Form -->
        <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
          <div
            class="my-auto mx-auto xl:ml-20 bg-white dark:bg-dark-1 xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto"
          >
            <h2
              class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left"
            >
              Registrar-se
            </h2>
            <!--
            <div
              class="intro-x mt-2 text-gray-500 dark:text-gray-500 xl:hidden text-center"
            >
              A few more clicks to sign in to your account. Manage all your
              e-commerce accounts in one place
            </div>-->
            <div class="intro-x mt-8">
              <input
                type="text"
                v-model="userData.name"
                class="intro-x login__input form-control py-3 px-4 border-gray-300 block"
                placeholder="Nome completo"
              />
              <input
                type="text"
                v-model="userData.username"
                class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                placeholder="Nome de usuário"
              />
              <input
                type="text"
                v-model="userData.email"
                class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                placeholder="Email"
              />
              <input
                type="password"
                v-model="userData.password"
                class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                placeholder="Senha"
              />
              <!--
              <div class="intro-x w-full grid grid-cols-12 gap-4 h-1 mt-3">
                <div class="col-span-3 h-full rounded bg-theme-9"></div>
                <div class="col-span-3 h-full rounded bg-theme-9"></div>
                <div class="col-span-3 h-full rounded bg-theme-9"></div>
                <div
                  class="col-span-3 h-full rounded bg-gray-200 dark:bg-dark-2"
                ></div>
              </div>
              <a
                href=""
                class="intro-x text-gray-600 block mt-2 text-xs sm:text-sm"
                >What is a secure password?</a
              >
              -->
            </div>
            <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
              <button
                @click="registerAccount()"
                class="btn btn-primary py-3 px-4 w-full xl:w-32 xl:mr-3 align-top"
              >
                Criar Conta
              </button>
              <button
                class="btn btn-outline-secondary py-3 px-4 w-full xl:w-32 mt-3 xl:mt-0 align-top"
              >
                <router-link :to="{ name: 'login' }" tag="a">
                  Voltar
                </router-link>
              </button>
            </div>
          </div>
        </div>
        <!-- END: Register Form -->
      </div>
      <div class="darkmode-menu">
        <DarkModeSwitcher />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue';
import DarkModeSwitcher from '@/components/dark-mode-switcher/Main.vue';
import AuthService from '../../services/auth/auth.service';
import { createToast } from 'mosha-vue-toastify';

export default defineComponent({
  components: {
    DarkModeSwitcher
  },
  data() {
    return {
      userData: {
        name: '',
        username: '',
        email: '',
        password: ''
      }
    };
  },
  methods: {
    async registerAccount() {
      const response = await AuthService.register(this.userData);
      if (response.status === 200) {
        this.$router.push({ name: 'login' });
        createToast('Conta criada com successo, entre com seus dados abaixo', {
          type: 'success',
          position: 'top-right',
          hideProgressBar: true,
          showIcon: true,
          transition: 'slide'
        });
      } else {
        createToast('Aconteceu algum erro, tente novamente mais tarde!', {
          type: 'warning',
          position: 'top-right',
          hideProgressBar: true,
          showIcon: true,
          transition: 'slide'
        });
      }
    }
  },
  setup() {
    onMounted(() => {
      cash('body')
        .removeClass('main')
        .removeClass('error-page')
        .addClass('login');
    });
  }
});
</script>

<style scoped>
.darkmode-menu {
  position: fixed;
  right: 0.5rem;
  top: 0.5rem;
}
</style>
